<main>
    <router-outlet />
</main>

@if (loading()) {
<app-animated-loader class="cover" />
}